/*
 * IMPORTANT: Длина названия лендинга должна быть как можно короче!
 * Иначе ловим xray_too_long вида "cloud_promo-cloud-valentines-day-pk-paint_score_needs-improvemen"
 */
export enum EPromoLandings {
    MOBILE = 'mobile',
    MOBILE_NEW = 'cloud-mobile-new',
    FILES_TRANSFER = 'files-transfer',
    PHOTO = 'photo',
    PHOTO_NEW = 'photo-new',
    PRO = 'pro',
    DOBRO = 'dobro',
    EDITOR = 'editor',
    CLOUD_WEB = 'cloudWeb',
    PARTNERS = 'partners',
    NEW_YEAR = 'new-year',
    EVENTS = 'events',
    TELEGRAM_MIGRATION = 'telegram-migration',
    FILES = 'cloud-files',
    PRESENT = 'present',
    NINE_MAY = 'cloud-promo-9may',
    MAIL = 'promo-mail',
    LOGIN = 'promo-login',
    PDF = 'cloud-promo-pdf-redaktor',
    DOCS = 'cloud-promo-docs',
    CLOUD_NEW = 'cloud-new',
    CLOUD_SECURITY = 'cloud-security',
    CLOUD_BOOK = 'cloud-promo-book',
    CLOUD_PROMO_REACH_CAMPAIGN = 'cloud-promo-reach-campaign',
    ClOUD_SAVE_OF_MEMORIES = 'cloud-save-of-memories',
    CLOUD_SUMMER_COLLAGE = 'summer-collage',
    CLOUD_VIGBO = 'cloud-vigbo',
    MAILSPACE25 = 'cloud-sp_mailspace25',
    CLOUD_VALENTINES_DAY = 'valentines26',
    CLOUD_KOTOPAD_GAME = 'kotopadgame',
}

export const PROMO_LANDING_TYPE = {
    'promo/files': EPromoLandings.FILES_TRANSFER,
    'promo/partners': EPromoLandings.PARTNERS,
    'promo/photo': EPromoLandings.PHOTO_NEW,
    'promo/pro': EPromoLandings.PRO,
    'promo/present': EPromoLandings.PRESENT,
    promocodes: EPromoLandings.PRESENT,
    photo_colorizer: EPromoLandings.NINE_MAY,
    'promo/mail': EPromoLandings.MAIL,
    'promo/login': EPromoLandings.LOGIN,
    'promo/pdf-redaktor': EPromoLandings.PDF,
    'promo/docs': EPromoLandings.DOCS,
    'promo/dobro': EPromoLandings.DOBRO,
    'promo/online-redaktor-dokumentov': EPromoLandings.EDITOR,
    'promo/newyear': EPromoLandings.NEW_YEAR,
    'promo/events': EPromoLandings.EVENTS,
    files_migration: EPromoLandings.TELEGRAM_MIGRATION,
    mobile: EPromoLandings.MOBILE,
    promo: EPromoLandings.CLOUD_WEB,
    'promo/cloud-files': EPromoLandings.FILES,
    'promo/summer': EPromoLandings.CLOUD_NEW,
    'promo/security': EPromoLandings.CLOUD_SECURITY,
    'promo/book': EPromoLandings.CLOUD_BOOK,
    'promo/memories': EPromoLandings.ClOUD_SAVE_OF_MEMORIES,
    'promo/summer_collage': EPromoLandings.CLOUD_SUMMER_COLLAGE,
    valentines26: EPromoLandings.CLOUD_VALENTINES_DAY,
    kotopadgame: EPromoLandings.CLOUD_KOTOPAD_GAME,
    'promo/mailvigbo': EPromoLandings.CLOUD_VIGBO,
    sp_mailspace25: EPromoLandings.MAILSPACE25,
};

export const PROMO_REG_EXP = new RegExp(`^/(${Object.keys(PROMO_LANDING_TYPE).join('|')})/?$`);

export enum EReactLandings {
    QUOTA = 'quota',
    QUOTA_IOS = 'quota/ios',
    QUOTA_ANDROID = 'quota/android',
    QUOTA_PARTNER = 'quota/partner',
    QUOTA_TARIFFS = 'quota/tariffs',
    QUOTA_TARIFFS_NEW = 'quota/tariffs/new',
    /** @deprecated Оставил для возможности редиректа с promo/quota-pro -> promo/quota, иначе 404 */
    QUOTA_PRO = 'quota-pro',
    UPLOADER = 'uploader',
    BUY = 'buy',
    CHOICE = 'choice',
    // tempexp_17127-next-line
    BUY_DISABLE_ADS = 'buy/disable-ads',
    BUY_MSP_PRO = 'buy/msp-pro',
    HAPPY_BIRTHDAY_CLOUD = 'happybirthdaycloud',
    FAMILY = 'family',
}

export const REACT_LANDING_TYPE = {
    'promo/quota': EReactLandings.QUOTA,
    'promo/quota/ios': EReactLandings.QUOTA_IOS,
    'promo/quota/android': EReactLandings.QUOTA_ANDROID,
    'promo/quota/partner': EReactLandings.QUOTA_PARTNER,
    'promo/quota/tariffs': EReactLandings.QUOTA_TARIFFS,
    'promo/quota/tariffs/new': EReactLandings.QUOTA_TARIFFS_NEW,
    /** @deprecated Оставил для возможности редиректа с promo/quota-pro -> promo/quota, иначе 404 */
    'promo/quota-pro': EReactLandings.QUOTA_PRO,
    uploader: EReactLandings.UPLOADER,
    buy: EReactLandings.BUY,
    choice: EReactLandings.CHOICE,
    // tempexp_17127-next-line
    'buy/disable-ads': EReactLandings.BUY_DISABLE_ADS,
    'buy/msp-pro': EReactLandings.BUY_MSP_PRO,
    'promo/happybirthdaycloud': EReactLandings.HAPPY_BIRTHDAY_CLOUD,
    'promo/family': EReactLandings.FAMILY,
};

export const REACT_LANDINGS_REG_EXP = new RegExp(`^/(${Object.keys(REACT_LANDING_TYPE).join('|')})/?$`);
